document.addEventListener('DOMContentLoaded', function () {
    console.log("Devstren");

    // Loox sets --loox-u-dynamic-carousel-review-font-size: 24px on .review-text inside Shadow DOM.
    (function styleLooxWidgets() {
      var LOOX_CSS =
        ':host {' +
        '  --loox-u-dynamic-carousel-review-font-size: 15px !important;' +
        '}' +
        '.loox-dynamic-carousel-widget .review-text,' +
        '.review-text,' +
        '.dynamic-carousel-text-swiper-content {' +
        '  --loox-u-dynamic-carousel-review-font-size: 15px !important;' +
        '  font-size: 15px !important;' +
        "  font-family: 'customfont', sans-serif !important;" +
        '}' +
        '.reviewer-name,' +
        'p {' +
        "  font-family: 'customfont', sans-serif !important;" +
        '}';

      function isLooxHost(el) {
        return el && el.tagName && el.tagName.toLowerCase().indexOf('loox-') === 0;
      }

      function inject(el) {
        if (!el) return true;
        var shadow = el.shadowRoot;
        if (!shadow) return false;

        if (!shadow.querySelector('style[data-loox-theme]')) {
          var style = document.createElement('style');
          style.setAttribute('data-loox-theme', '1');
          style.textContent = LOOX_CSS;
          shadow.appendChild(style);
        }

        shadow.querySelectorAll('.review-text').forEach(function (node) {
          node.style.setProperty('--loox-u-dynamic-carousel-review-font-size', '15px', 'important');
        });

        if (!el._looxObserved) {
          el._looxObserved = true;
          new MutationObserver(function () {
            inject(el);
          }).observe(shadow, { childList: true, subtree: true });
        }

        shadow.querySelectorAll('*').forEach(function (child) {
          if (child.shadowRoot) inject(child);
        });
        return true;
      }

      function scan(root) {
        if (!root) return;
        if (isLooxHost(root)) watchUntilReady(root);
        if (!root.querySelectorAll) return;
        root.querySelectorAll('*').forEach(function (el) {
          if (isLooxHost(el)) watchUntilReady(el);
        });
      }

      function watchUntilReady(el) {
        if (inject(el)) return;
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (inject(el) || tries > 50) clearInterval(timer);
        }, 200);
      }

      scan(document.body);

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (isLooxHost(node)) watchUntilReady(node);
            scan(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    })();

    // Select all trigger buttons for these custom tabs
    const tabTriggers = document.querySelectorAll('.product-tabcustom__trigger');

    tabTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const targetPanel = document.querySelector(targetId);

        // if first faq not open , all close
        if (this.classList.contains('collapsed')) {
            tabTriggers.forEach(function (otherTrigger) {
            if (otherTrigger !== trigger) {
                const otherTargetId = otherTrigger.getAttribute('data-target');
                const otherPanel = document.querySelector(otherTargetId);

                // Close other triggers
                otherTrigger.classList.add('collapsed');
                otherTrigger.setAttribute('aria-expanded', 'false');

                // Close other panels
                if (otherPanel) {
                otherPanel.classList.remove('show');
                }
            }
            });
        }
        });
    });


});
